import { Header } from "./components/sections/Header";
import Amenities from "./components/sections/Amenities";
import { Noise } from "./components/Noise";
import Stages from "./components/sections/Stages";
import Main from "./components/sections/Main";
import { Gradients } from "./components/Gradients";
import Cases from "./components/sections/Cases";
import { Form } from "./components/sections/Form";
import { Footer } from "./components/sections/Footer";
import ScrollToHashOnLoad from "./components/ScrollToHash";

function App() {
  return (
    <ScrollToHashOnLoad>
      <Header />
      <main
        data-vaul-drawer-wrapper
        className="flex min-h-[200vh] w-full flex-col items-center justify-center overflow-hidden"
      >
        <div className="flex flex-col gap-25 items-center justify-center w-full max-w-360 relative z-10">
          <Gradients />
          <Noise />
          <Main />
          <Amenities />
          <Stages />
          <Cases />
          <Form />
          <Footer />
        </div>
      </main>
    </ScrollToHashOnLoad>
  );
}

export default App;
